import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Loader2, Check, AlertCircle } from 'lucide-preact';
import { BRAND_CLASSES } from '@/constants/theme';
/**
 * Compact text + icon save-status pill used by every auto-saving editor (Email Copy fields,
 * Email Template canvas, etc.). Renders a single line — caller controls placement.
 */
export function SaveStatusIndicator({ status, error, onRetry }) {
    if (status === 'saving') {
        return (_jsxs("span", { className: `inline-flex items-center gap-1 text-[11px] ${BRAND_CLASSES.INPUT.HELPER}`, children: [_jsx(Loader2, { className: "w-3 h-3 animate-spin" }), "Saving\u2026"] }));
    }
    if (status === 'dirty') {
        return (_jsx("span", { className: `text-[11px] ${BRAND_CLASSES.INPUT.HELPER}`, children: "Unsaved changes" }));
    }
    if (status === 'saved') {
        return (_jsxs("span", { className: "inline-flex items-center gap-1 text-[11px] text-emerald-600 dark:text-emerald-400", children: [_jsx(Check, { className: "w-3 h-3" }), "Saved"] }));
    }
    if (status === 'error') {
        return (_jsxs("span", { className: `inline-flex items-center gap-1.5 text-[11px] ${BRAND_CLASSES.INPUT.ERROR_TEXT}`, children: [_jsx(AlertCircle, { className: "w-3 h-3" }), error || 'Save failed', _jsx("button", { type: "button", onClick: onRetry, className: "underline decoration-dotted underline-offset-2 hover:text-red-700 dark:hover:text-red-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 rounded", children: "Retry" })] }));
    }
    return _jsx("span", { className: `text-[11px] ${BRAND_CLASSES.INPUT.HELPER}`, children: "\u2014" });
}
